import { render } from "./videoLibraryManage.vue?vue&type=template&id=4da68fc7&scoped=true"
import script from "./videoLibraryManage.vue?vue&type=script&lang=js"
export * from "./videoLibraryManage.vue?vue&type=script&lang=js"

import "./videoLibraryManage.vue?vue&type=style&index=0&id=4da68fc7&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da68fc7"]])

export default __exports__